import { createStyles, makeStyles } from "@material-ui/core";

const styles = () =>
  createStyles({
    placeholderLikeLabel: {
      "& input::placeholder": {
        opacity: 1,
        color: "inherit"
      }
    }
  });

const useStyles = makeStyles(styles);

export default useStyles;
